export const WORDS = [
'Eller',
'Piper',
'Kelly',
'Gator',
'Leyba',
'Welty',
'Woods',
'Guffy',
'Rugby',
'Dutch',
'Renke',
'Class',
'Magis',
'Ricci',
'Saint',
'Faber',
'Block',
'Jesus',
'Fisko',
'Faith',
'Klein',
'APUSH',
'Walsh',
'Angus',
'Smith',
'Aston',
'Stuco',
'Clubs',
'Teams',
'Deans',
'Curry',
'Sport',
'Munro',
'Covid',
'Bands',
'Break',
'Lunch',
'Learn',
]
